import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { SwapProfilerLibraryDialogComponent } from '../swap-profiler-library-dialog/swap-profiler-library-dialog.component';
import { DialogWidth } from 'src/app/shared/atlas-dialog/enums/dialog-width.enum';
import { DialogService } from 'src/app/core/services/dialog.service';
import * as fromProfilerStore from 'src/app/profiler-store';
import { Store } from '@ngrx/store';
import {
  getLibrariesCount,
  getProfilerLibraryId
} from 'src/app/profiler-store';
import { Subscription } from 'rxjs';

@Component({
    selector: 'atlas-swap-profiler-library',
    templateUrl: './swap-profiler-library.component.html',
    styleUrls: ['../../less/library-management-button.component.less'],
    standalone: false
})
export class SwapProfilerLibraryComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  private libraryId$ = this.store$.select(getProfilerLibraryId);
  librariesCount$ = this.store$.select(getLibrariesCount);
  currentLibraryId: number;

  @Output() swapLibraryClicked = new EventEmitter();
  constructor(
    public dialogService: DialogService,
    private store$: Store<fromProfilerStore.State>
  ) {}

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  ngOnInit(): void {
    this.subscription.add(
      this.libraryId$.subscribe((id) => {
        this.currentLibraryId = id;
      })
    );
  }
  onSwapLibrary() {
    this.dialogService.show(SwapProfilerLibraryDialogComponent, {
      width: DialogWidth.Small,
      panelClass: 'dialog-full-width-height',
      data: {
        headerText: $localize`:@@switchProfileHeader:Switch Profile`,
        currentLibraryId: this.currentLibraryId
      },
      disableClose: true
    });
  }
}
